import { createRoutine } from 'redux-saga-routines'

export const SET = 'LOGIN_LAYOUT/SET'
export const CONTENT = createRoutine('LOGIN_LAYOUT/CONTENT')
